import { IToken } from '@shared';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { IUser } from '@interfaces';
//import { User } from '../models/auth.models';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private cookieService: CookieService) {}

  setToken(token: string, key: string, rememberMe: boolean = false, userCredentials?: IUser) {
    this.cookieService.set(key, token.replace(/"/g, ''), { path: '/', secure: true });
    if (rememberMe && userCredentials) {
      this.cookieService.set('userEmail', userCredentials.email, { path: '/', secure: true });
      return;
    }
    this.cookieService.delete('userEmail', '/');
  }

  getTokens(): IToken {
    return {
      accessToken: this.cookieService.get('accessToken'),
      refreshToken: this.cookieService.get('refreshToken'),
      businessportalAccessToken: this.cookieService.get('businessportalAccessToken'),
      businessportalRefreshToken: this.cookieService.get('businessportalRefreshToken'),
    };
  }
}
